import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StandardLanding from '../../../shared/components/StandardLanding';
import TablePlanProgram from '../components/TablePlanProgram';
import { getReportType, getPlanProgramList } from '../../general/action';
import { deletePlan, updatePlanStatus } from '../action';
import { getUnitList } from '../../user-accounts/action';

const Landing = () => {
    const dispatch = useDispatch();
    const state = useSelector(state => state);
    const { reportType, listPlanProgram, loading } = state.general;
    const { listUnit } = state.account;

    useEffect(() => {
        const name = 'plans_programs';
        dispatch(getReportType(name));
        dispatch(getPlanProgramList());
        dispatch(getUnitList());
    }, []);

    return (
        <StandardLanding>
            <div className="main-container content-crop">
                <div className="flex justify-between">
                    <p className="lg-title text-blue-10">PLANS AND PROGRAMS</p>
                    <p className="md-title text-gray-20">View tabulated summary of reports here</p>
                </div>
                <div className="mt-2">
                    <TablePlanProgram
                        loading={loading}
                        reportType={reportType}
                        deletePlan={deletePlan}
                        listUnit={listUnit}
                        listPlanProgram={listPlanProgram}
                        updatePlanStatus={updatePlanStatus}
                        getPlanProgramList={getPlanProgramList}
                    />
                </div>
            </div>
        </StandardLanding>
    );
};

export default Landing;
